import { Box, Button, FormControl, InputLabel, MenuItem, Modal, Paper, Select, Tab, Tabs, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Snackbar, Alert } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import app, { db } from '../../firebase';
import firebase from 'firebase/compat/app'
import AppNavBar from './AppNavBar';
import emailjs from '@emailjs/browser';
import InactivityModal from './Inactive';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: 400,
    bgcolor: 'white',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflowY:'scroll'
  };
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
function Create() {
    let {id} = useParams()
    const [value, setValue] = useState(0);
    const history = useNavigate()
    const [page, setPage_t] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [openModal, setOpenModal] = React.useState(false);
     const [name,setName] = useState('')
    const [email,setEmail] = useState('')
    const [phone,setPhone] = useState('')
    const [users, setUsers] = useState([])
    const [users_my, setUsers_my] = useState([])
    const [lname,setLname] = useState('')
    const [source,setSource] = useState('website')
    const [key,setKey] = useState('')
    const [times,setTime] = useState('')
    const [filter, setFilter] = React.useState('name');
    const [selectedId, setSelectedId] = useState('')
    const [error, setError] = React.useState(null);
    const [msg, setMsg] = React.useState(null);
    const [tab, setTab] = React.useState(0);
    var date = new Date().toUTCString()

    const handleOpenModal = () => {
        setSelectedId('')
        setName('')
        setEmail('')
        setLname('')
        setOpenModal(true);
    }
     const handleCloseModal = () => {
        setOpenModal(false);
    }
     const handleChangePage = (event: unknown, newPage: number) => {
        setPage_t(newPage);
    };
  
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage_t(0);
    };
    const [open2, setOpen2] = React.useState(false);
    const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => {
    setOpen2(false);
  }
    const generateToken = (len) => {
        let result = [];
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charLength = characters.length;
        for (let i = 0; i < len; i++) {
            result.push(characters.charAt(Math.floor(Math.random() * charLength)));
        }
        return result.join('');
      }
    useEffect(() => {
       db.collection('users').onSnapshot(snapshot=> {
          let cald = [];
          snapshot.forEach(snap => {
              cald.push(snap.data());
          });
          setUsers(cald) 
        })
    }, [])
       function handleSearch(e){
      db.collection('users').orderBy(filter)
      .startAt(e.target.value.toLowerCase())
      .endAt(e.target.value.toLowerCase() + "\uf8ff").get().then(function(snapshot) {
        let cald = [];
        snapshot.forEach(snap => {
            cald.push(snap.data());
        });
        setUsers(cald) 
      });
      }
  return (
    <div>
    <AppNavBar id={id}/>
    <InactivityModal/>
       <Paper style ={{margin:'2rem',padding:'1rem'}}>
        <div style={{width:'fit-content', margin:'0px auto', display:'flex',gap:'1rem',marginBottom:'1rem'}}>
        <Typography align='center'> Accounts</Typography>
        </div>
        <>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <Button variant='contained'
          onClick={handleOpenModal}>Create Account</Button>
          <div>
          <TextField
            id="outlined-basic" label="Search" variant="outlined"
            onChange={handleSearch}
         />
         <Snackbar
                    open={Boolean(msg)}
                    anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                    autoHideDuration={8000} 
                    onClose={() => setMsg(null)}
                >
                    <Alert
                        onClose={() => setMsg(null)} 
                        severity="success"
                        variant="outlined"
                    >
                        {msg}
                    </Alert>
                </Snackbar>
              <FormControl  >
        <InputLabel id="demo-simple-select-label">Filter</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={filter}
          label="Filter"
          onChange={(e)=>{
            setFilter(e.target.value);
            }}
        >
          <MenuItem value='name'>First Name</MenuItem>
          <MenuItem value='id'>ID</MenuItem>
            <MenuItem value='lname'>Last Name</MenuItem>
        </Select>
      </FormControl>
          </div>
        </div>
<TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
             <TableCell>
                 First Name
            </TableCell>
            <TableCell>
              Last Name
            </TableCell>
            <TableCell>
                 Email
            </TableCell>
            <TableCell>
                Action
            </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
           {users
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((data) => {
                return (
                  <TableRow tabIndex={-1} key={data.key}>
                  <TableCell scope="row">
                   {data.name}
                  </TableCell>
                  <TableCell scope="row">
                    {data.lname}
                  </TableCell>
                    <TableCell scope="row">
                    {data.email}
                  </TableCell>
                  <TableCell scope="row">
                    <a style={{color:'blue', cursor:'pointer'}}
                    onClick={()=>{
                     setSelectedId(data.id)
                     setName(data.name)
                     setEmail(data.email)
                     setLname(data.lname)
                     setOpenModal(true)
                    }}>Edit</a>
                    <br/>
                    <a style={{color:'red', cursor:'pointer'}}
                    onClick={()=>{
                      setSelectedId(data.id)
                     setOpen2(true)
                    }}>Revoke Account</a>
                  </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={users.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
          </>
        
        </Paper>
        <Modal
    open={openModal}
    onClose={handleCloseModal}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    >
    <Box sx={style}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
      CREATE ACCOUNT
    </Typography>
   <TextField
          id="outlined-basic" label='First Name' variant="outlined" focused
          value={name} onChange={(e)=>{setName(e.target.value)}}
          fullWidth
          style={{marginBottom:'1rem'}}
        />
        <TextField
          id="outlined-basic" label='Last Name' variant="outlined" focused
          value={lname} onChange={(e)=>{setLname(e.target.value)}}
          fullWidth
          style={{marginBottom:'1rem'}}
        />
        <TextField
          id="outlined-basic" label='Email' variant="outlined" focused
          value={email} onChange={(e)=>{setEmail(e.target.value)}}
          fullWidth
          style={{marginBottom:'1rem'}}
        />
        
          <Button variant="outlined" onClick={()=>{
            try{
              if(!selectedId){
               let key = name.toLowerCase()+generateToken(3)
             db.collection('users').doc(email.toLowerCase()).set({
                name: name.toLowerCase(),
                email: email.toLowerCase(),
                id: email.toLowerCase(),
                lname:lname,
                password: key,
                type:'admin'
              }); 
                var templateParams = {
                    email: email.trim(),
                    subject: 'New Account',
                    message: 'Your account has been Email: '+' Username: '+email.trim()+' Password: '+key,
                    comp_name: 'Dev Arena'
                   
                 };
         emailjs.send("service_oiqb0bo","template_ntw8bxg",templateParams,"wwlXdyG0epB_-bxgu")
            .then(function(response) {
              setMsg('Profile created successfully!!!')
            }, function(error) {
              console.log(error)
            }); 
              
              }
              else
              {
                db.collection('users').doc(selectedId).update({
                name: name.toLowerCase(),
                email: email.toLowerCase(),
                lname:lname.toLowerCase(),
              }); 
              }
                
            handleCloseModal()
            }catch{

            }
          }}>Submit</Button>
    </Box>
    </Modal>
<Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        
          <>
         <Typography>Are you sure you want to delete this account?</Typography>
        <Button variant='contained'
        onClick={handleClose2}>
        Cancel
        </Button>
         
  <Button variant='outlined'
        onClick={()=>{
          db.collection('users').doc(selectedId).delete();
          handleClose2()
        }}>
        Yes
        </Button>
        
          </>
        
         
        </Box>
      </Modal>
    </div>
  )
}

export default Create